/**
 * Method to create a delay of @param delay milliseconds.
 * @param {number} delay Amount of milliseconds to wait for.
 * @returns A promise that is self-resolved within the specified delay.
 */
export const waitFor = delay =>
  new Promise(resolve => setTimeout(resolve, delay));
